import { render } from "./ProductDetail.vue?vue&type=template&id=93ffeda8&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=93ffeda8&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=1&id=93ffeda8&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ffeda8"]])

export default __exports__